export const LivePlayer = ({ show, src }: { show?: boolean, src: string }) => {
    if (!show) return null;
    return <section style={{ display: "flex", background: "var(--color-header-background-top)", padding: "20px", margin: 0 }}>
        <div style={{ aspectRatio: '16/9', flex: 1, maxWidth: '640px', margin: '0 auto' }}>
            <iframe
                src={src}
                title='Live TV'
                width="100%"
                height="100%"
                frameBorder='0'
                style={{ border: 0 }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </div>
    </section>
}